<template>
  <div class="vm-detail-shell" :id="shellId">
    <div class="table-wrapper-scroll-y vm-image-table-scroll">
      <table class="table table-striped table-bordered table-condensed vm-detail-table-wrap">
        <thead>
          <tr>
            <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">OS</div></th>
            <th class="col-sm-2 col-md-2 col-lg-3"><div class="text-center">VM Image SnapShot Name</div></th>
            <th class="col-sm-3 col-md-3 col-lg-3 hidden-phone"><div class="text-center">Size</div></th>
            <th class="col-sm-3 col-md-3 col-lg-3 hidden-tablet"><div class="text-center">Uploaded Date</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">Owner</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1 vm-image-actions-col"><div class="text-center">Operation</div></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="row in data.rows || []" :key="`vm-image-${row.id}`">
            <td><div class="text-center"><img :src="row.os_icon_url" width="20" height="20" alt=""></div></td>
            <td>
              <div class="text-center">
                <a
                  :href="row.detail_page_url"
                  class="vm-detail-link"
                  :data-vm-image-detail-url="row.detail_url"
                >{{ row.name }}</a>
              </div>
              <div class="modal hide fade" :id="row.detail_modal_id" role="dialog" aria-hidden="true"></div>
            </td>
            <td class="hidden-phone"><div class="text-center">{{ row.size }}</div></td>
            <td class="hidden-tablet"><div class="text-center">{{ row.updated_at }}</div></td>
            <td><div class="text-center">{{ row.owner }}</div></td>
            <td class="vm-image-actions-col" v-html="row.action_html"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <aside
      :id="`${shellId}-panel`"
      class="vm-detail-panel"
      aria-hidden="true"
      data-vue-component="vm-image-detail-panel"
      :data-vue-props="JSON.stringify({ shellId })"
    ></aside>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [], shell_id: 'vm-image-detail-shell' })
  }
})

const data = ref(props.initialData || { rows: [], shell_id: 'vm-image-detail-shell' })
const shellId = computed(() => data.value.shell_id || 'vm-image-detail-shell')

watch(
  () => props.initialData,
  (nextValue) => {
    data.value = nextValue || { rows: [], shell_id: 'vm-image-detail-shell' }
  }
)

function mountNestedVue() {
  if (window.sccMountVueComponents) {
    window.sccMountVueComponents()
  }
}

onMounted(() => {
  nextTick(mountNestedVue)
})

watch(data, () => {
  nextTick(mountNestedVue)
})
</script>
